import { CaretUp, CaretDown, Minus } from "@phosphor-icons/react";
import { fmtPct } from "../lib/format";

export function ChangeIndicator({ value, size = "sm", className = "" }) {
  if (value == null || isNaN(value)) {
    return (
      <span className={`inline-flex items-center gap-1 text-neutral font-mono ${size === "lg" ? "text-base" : "text-xs"} ${className}`} data-testid="change-neutral">
        <Minus weight="bold" size={size === "lg" ? 16 : 12} /> —
      </span>
    );
  }
  const up = value > 0;
  const down = value < 0;
  const color = up ? "text-success" : down ? "text-danger" : "text-neutral";
  const Icon = up ? CaretUp : down ? CaretDown : Minus;
  return (
    <span className={`inline-flex items-center gap-1 font-mono font-medium ${color} ${size === "lg" ? "text-base" : "text-xs"} ${className}`} data-testid="change-indicator">
      <Icon weight="fill" size={size === "lg" ? 16 : 12} />
      {fmtPct(value)}
    </span>
  );
}
